/**
 * BrandWordmark
 * =============
 * The default zCortexAI product wordmark — a gradient logo mark holding a "z",
 * followed by the Cortex/AI lockup. Shared by the public landing page and the
 * auth pages so the brand identity stays consistent across the unauthenticated
 * surface.
 *
 * `tone` controls the "Cortex" text color so the same mark reads correctly on
 * both dark branding panels (`light`) and light form backgrounds (`dark`).
 */

import React from 'react';

const TONES = {
  light: 'text-white',
  dark: 'text-neutral-900',
};

const SIZES = {
  sm: { mark: 'h-6 w-6 rounded-md', z: 'text-sm', text: 'text-lg' },
  // md mirrors the landing header's original wordmark proportions.
  md: { mark: 'h-9 w-9 rounded-xl', z: 'text-lg', text: 'text-xl' },
  lg: { mark: 'h-6 w-6 rounded-md', z: 'text-xl', text: 'text-3xl' },
};

const BrandWordmark = ({ tone = 'light', size = 'md', className = '' }) => {
  const s = SIZES[size] || SIZES.md;
  const textTone = TONES[tone] || TONES.light;

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      {/* Logo mark: gradient tile with a standalone "z" */}
      <span
        className={`relative flex items-center justify-center bg-gradient-to-br from-accent to-primary shadow-accent ${s.mark}`}
      >
        <span className={`font-bold leading-none text-white ${s.z}`}>z</span>
      </span>

      {/* Wordmark — leading-none so the tile centers against the cap height */}
      <span className={`font-bold leading-none tracking-tight ${s.text} ${textTone}`}>
        Cortex<span className="text-accent">AI</span>
      </span>
    </span>
  );
};

export default BrandWordmark;
